import React from "react";

export const ThemeLightState = ({ className, divClassName, text }) => {
  return (
    <div
      className={`flex items-center justify-center px-[12px] py-2 relative rounded-[12px] border border-solid border-[rgba(247,132,255,0.5)] bg-[linear-gradient(161deg,#FFF_48.34%,rgba(255,255,255,0.00)_128.53%)] shadow-[0px_2px_3px_0px_rgba(204,205,207,0.15)] ${className}`}
    >
      <div className={`relative w-fit text-[#f784ff] font-medium text-center ${divClassName}`}>{text}</div>
    </div>
  );
};
